export const config = () => {
  return {
    apiBaseUrl: "https://ipanel.barsoft.hu/",
    apiBaseUrl2: "https://ipanel.okeoke.io/",
    apiBaseUrl1: "http://localhost:4500/",
  };
};
